import { render, staticRenderFns } from "./index.vue?vue&type=template&id=08292bf0&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "index.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/layout/components/Sidebar/index.vue
// module id = null
// module chunks = 